<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!windowService?.isDesktopRes) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="'Checklists'"
      [canGoBack]="true" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>
    <!--@for (form of forms.controls; track form; let i = $index) {
      <tidy-card>
        <tidy-row class="card-header">
          <tidy-text [header]="addresses[i].address1" />
        </tidy-row>
        <tidy-row>
          <form [formGroup]="form">
            <tidy-select
              [label]="'# Bedrooms'"
              [form]="form.controls.beds"
              formControlName="beds"
              [items]="roomOptions" />
          </form>
        </tidy-row>
        <tidy-row>
          <form [formGroup]="form">
            <tidy-select
              [label]="'# Bathrooms'"
              [form]="form.controls.baths"
              formControlName="baths"
              [items]="roomOptions" />
          </form>
        </tidy-row>
        <tidy-row>
          <form [formGroup]="form">
            <tidy-select
              [label]="'# Floors'"
              [form]="form.controls.floors"
              formControlName="floors"
              [items]="floorOptions" />
          </form>
        </tidy-row>
      </tidy-card>
    }-->

    <tidy-row [align]="'center'" class="extra-bottom-padding">
      <tidy-text [body]="'Please reach out to our concierge if you have any questions or to get help setting up checklists.'" />
    </tidy-row>

    <tidy-button
      [text]="'Get Started'"
      [action]="boundSave"
      class="primary" />
  </tidy-wrapper>
</ng-template>

@if (!windowService?.isDesktopRes) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (windowService?.isDesktopRes) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
